module.exports = __webpack_public_path__ + "static/media/caret-left.138a7f6e.svg";